import React from "react";
import { Typography as T } from "@mui/material";

import { palette } from "theme/palette";

type Props = {
  styles?: React.CSSProperties;
};

const RequiredStar = ({ styles }: Props) => {
  return (
    <T
      variant="h5md"
      sx={{
        color: palette.warning,
        ...styles,
      }}
    >
      *
    </T>
  );
};

export { RequiredStar };
